{
	"widgetActions": {
		"settingsColumns": "Column settings"
	},
	"orders": {
		"typesAssets": {
			"stocks": "Stocks",
			"options": "Options",
			"postTrading": "Post-trading"
		},
		"activeOrders": {
			"filled": "Filled",
			"open": "Open",
			"canceled": "Canceled",
			"OPEXC": "Expired",
			"OPEXP": "Exercises",
			"OPASN": "Assigned"
		}
	}
}
